@layer ui-kit;
@layer ui-kit {
  ._10qh2ik0 {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  ._10qh2ik1 {
    display: flex;
    position: relative;
    user-select: none;
    touch-action: none;
    align-items: center;
    margin-bottom: 10px;
  }
  ._10qh2ik1[data-disabled] {
    opacity: 0.5;
    pointer-events: none;
  }
  ._10qh2ik2 {
    margin-bottom: 12px;
  }
  ._10qh2ik3 {
    position: relative;
    background-color: var(--_1qu8za24r);
    border-radius: 4px;
    flex-grow: 1;
    height: 4px;
  }
  ._10qh2ik4 {
    position: absolute;
    background-color: var(--_1qu8za24p);
    border-radius: 12px;
    height: 100%;
  }
  ._10qh2ik5 {
    display: block;
    height: 24px;
    width: 24px;
    background-color: var(--_1qu8za24p);
    border: 1px solid var(--_1qu8za24r);
    border-radius: 100%;
    filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.1));
    transform: translateZ(0);
  }
  ._10qh2ik6 {
    font-weight: 500;
    font-size: 14px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--_1qu8za25);
  }
  ._10qh2ik7 {
    font-weight: 500;
    font-size: 14px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    color: var(--_1qu8za24p);
    background-color: var(--_1qu8za24r);
    padding: 2px 8px;
    border-radius: 60px;
    opacity: 0;
    pointer-events: none;
    white-space: nowrap;
    position: absolute;
    left: 50%;
    top: -8px;
    transform: translate(-50%, -98%) scale(0.96);
    transition: opacity 150ms;
  }
  ._10qh2ik5:hover ._10qh2ik7, ._10qh2ik5:focus-visible ._10qh2ik7 {
    opacity: 1;
    transform: translate(-50%, -100%) scale(1);
  }
}